import firebaseApp from "../firebase/credenciales";
import { getFirestore, doc, updateDoc } from "firebase/firestore";
import escribirLog from "./escribirLog";
import Swal from 'sweetalert2'

const db = getFirestore(firebaseApp);

export default async function eliminarUsuario(producto, autor, baseDatos) {

  let title = '¿Estás seguro?';
  let text = "¡No podrás revertir esto!";
  let confirmButtonText = '¡Sí, bórralo!';

  if (baseDatos === 'users') {
    title = '¿Desactivar usuario?';
    text = "El usuario podrá seguir ingresando al sistema, pero ya no aparecerá en la lista de usuarios.";
    confirmButtonText = 'Sí, desactivar';
  }

  //Alerta de confirmación
  const { value: confirmar } = await Swal.fire({
    title: title,
    text: text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: confirmButtonText
  })

  //Si se confirma la eliminación
  if (confirmar) {
    //Elimina el producto modifica el campo activo
    const userRef = doc(db, baseDatos, producto.id)
    const eliminado = await updateDoc(userRef, {
      activo: false
    });

    /*si se quiere eliminar al usuario de la base de datos utilice este codigo
    const eliminado = await deleteDoc(doc(collection(db, baseDatos), producto.id))*/

    let actionName = "Eliminación";
    if (baseDatos === 'users') {
      actionName = "Desactivación";
    }

    escribirLog(actionName, producto, autor);
    return true;


  } else {
    //Si no se confirma la eliminación, no hace nada
    return false;
  }



}
